import { Component } from "react";

export default class TalaeraDefaultBackground extends Component {
  render() {
    return <div className="talaera-default-background">{this.props.children}</div>;
  }
}
